import { render } from "./EditTask.vue?vue&type=template&id=035b6f76&ts=true"
import script from "./EditTask.vue?vue&type=script&lang=ts"
export * from "./EditTask.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__